import { Link } from "react-router-dom";

export const LegalFooter = () => (
  <footer className="border-t border-border bg-card/40 px-6 py-4 text-xs text-muted-foreground flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between">
    <div>
      ⚠️ Educational tool only. Not medical advice. AI output may be inaccurate, verify, patch-test, and formulate at your own risk.
    </div>
    <div className="flex gap-4 shrink-0">
      <Link to="/terms" className="hover:text-foreground underline-offset-4 hover:underline">Terms</Link>
      <Link to="/privacy" className="hover:text-foreground underline-offset-4 hover:underline">Privacy</Link>
      <Link to="/disclaimer" className="hover:text-foreground underline-offset-4 hover:underline">Disclaimer</Link>
      <span className="opacity-70">Some links are affiliate links.</span>
    </div>
  </footer>
);